export enum IncidentBannersIndices {
	KEY = 'by-key',
	BY_PROJECT_PER_STATUS_PER_ISSUE = 'by-project-and-status-per-issueId',
	BY_SERVICEDESK_AND_STATUS = "by-servicedesk-and-status",
}

export type IncidentBannerEntity = {
	content: string;
	createAccountId: string;
	createdAt: number;
	inactiveChangedAt: number | undefined;
	issueId: string;
	name: string;
	projectId: string;
	serviceDeskId: string;
	status: IncidentBannerStatus;
	updateAccountId: string | undefined;
	updatedAt: number | undefined;
};

export type IncidentBannerDto = IncidentBannerEntity & {
	key: string;
};

export type IncidentBannerSaveDto = Pick<IncidentBannerDto, 'content' | 'issueId' | 'name' | 'projectId'>;

export type IncidentPortalBannerDto = Pick<IncidentBannerEntity, 'content'> & {
	order: number;
};

export enum IncidentBannerStatus {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
}
